import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import ReactSelect from "../../../components/Select";
import appStore,{activePeriod} from '../../../store';

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function PerformanceReport({ data }:any)  {
const [hide,set_hide] = useState<boolean>(true);
const queryClient = useQueryClient();
const [enable,set_enable] = useState(0);
const [,set_open] = useAtom(openAtom);
const [,set_Nopen] = useAtom(openNAtom);
const [,set_notification]= useAtom(notificationAtom);
const aPeriod = appStore.get(activePeriod)?.Id;
const [selected_examperiod,set_selected_examperiod] = useState<string>(aPeriod?.toString()|| '');
 const [selected_subject,set_selected_subject] = useState<string>('');

 const {data:allExamPeriod} = useQuery(['exam-period'],{
  queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
  select(data){
    // console.log(data.data.Data,'data array')
    return data.data.Data;

  },
});

 const {data:allstudentPerformance, isLoading} = useQuery<any>(['performance'+enable],{
  queryFn:async()=>await apiCall().get(`/ExamReport/studentPerformanceReport?ExamPeriodId=${selected_examperiod ||''}&ExamSubjectId=${selected_subject || ''}`,{
    //ExamPeriodId:data?.ExamPeriod.Id,
    //ExamSubjectId:data?.ExamSubjectId
    }),
  enabled:Boolean(enable),
  select(data){
    console.log(data.data.Data,'performance')
    return data.data.Data;
  }
});


  
    const {data:allExamSubject} = useQuery(['exam-subject'],{
      queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
      select(data){
        // console.log(data.data.Data,'subject data')
        return data.data.Data;
      },
    })


  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(allstudentPerformance || []);

  
  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(allstudentPerformance)
    }
    else set_filter_data(allstudentPerformance)
  }

  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  }; 

  const handleFilter = (e:any) =>{
    const value = Number(e?.target?.value || 0);
    //console.log(value)

    if(value || !isNaN(value)){
       let data = allstudentPerformance?.filter((eData:any) => {
        console.log(eData.Level,'Level')
        return eData.Level.Id == value});
      set_filter_data(data && data.length > 0 ?data : allstudentPerformance)
    }
    else{
      set_filter_data(allstudentPerformance) 
    }

  } 

  const handleChangePeriod = (value:any) =>{
    //console.log(value,'value')
    if(value){
      set_selected_examperiod(value?.Id);
      // let check:any = allcandidateRegistration.filter((e:any) => e.ExamPeriod == value.ExamName);
      //set_filter_data(check)
    
    }
  }

  const {mutate:handleDownload,isLoading:isDownloading} = useMutation({
      mutationKey:[],
      mutationFn:async ()=> {
        const url = `/ExamReport/downloadStudentPerformanceReport?ExamPeriodId=${selected_examperiod}&ExamSubjectId=${selected_subject || ''}`,method = "POST",body = {},config = {},download = true;
        return await downloadApi(url,method,body,config,download)
  
      },
      onSuccess:async(data:any)=>{
        //initial the download 
        console.log(data,'download data')
        let file = data;
       
        if(file){
          
          const url = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "student-performance-report.xlsx");
          document.body.appendChild(link);
          link.click();
          console.log(file,'data')
          set_notification({
            type:'success',
            message:data?.data?.Message || 'Performance Report Downloaded Successfully'
          })
          set_Nopen(true);
        }
        else{
          set_notification({
            type:'error',
            message:'Oooops! Error Occured trying to download file'
          })
          set_Nopen(true);
        }
        
      },
      onError(error:any, variables, context) {
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }
  
    } )
    
  
    useEffect(()=>{
      set_filter_data(allstudentPerformance)
    },[allstudentPerformance])
    useEffect(()=>{
      
      if( (selected_subject ||selected_examperiod) ){
        set_enable(enable => enable + 1);
      }
    },[selected_examperiod,selected_subject])
    useEffect(()=>{
      if(aPeriod){
        set_selected_examperiod(aPeriod.toString())
      }
    },[aPeriod])
  return (
    <>
   {isLoading?<Loader />:

    <Box>
      <TopDisplay label="Student Performance Report" button_array={[
        
          <Button disabled={isDownloading} type="submit" color="var(--white-color)" 
          bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
          onClick={()=>handleDownload()} 
        > {isDownloading?"DownLoading":'Download Performance Report'}</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <ReactSelect 
              name="ExamName"
              onChange={handleChangePeriod}
              placeholder="Exam Period"
              options={allExamPeriod?.map((e:any)=> ({...e,['label']:e.ExamName,['value']:e.Id}))} />
          {/* <Select placeholder='Exam Period' width="140px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>{
              if(e.target.value)set_enable(enable+1);
              set_selected_examperiod(e.target.value)
            }}
                name="ExamPeriodId"
              >
               {allExamPeriod && allExamPeriod.length > 0 ?
                  allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>)
                :''}
              </Select> */}
               <Select placeholder='Subject' width="140px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_subject(e.target.value)}
                name="ExamSubjectId"
              >
                <>{allExamSubject && allExamSubject.length > 0 ?
                  allExamSubject.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                :''}</>
              </Select>
          </Flex>
      
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Student Performance Report</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
        {  filter_data && filter_data.length > 0 ?  <TableContainer mt="20px">
        <Table size='sm'>
          <Thead>
            <Tr >
            <Th sx={HeadStyle}>ExamDiet</Th>
              <Th sx={HeadStyle}>Level</Th>
              <Th sx={HeadStyle}>Subject</Th>
              <Th sx={HeadStyle}>Numb.Of Candidates</Th>
              <Th sx={HeadStyle}>Numb.Of Passed</Th>
              <Th sx={HeadStyle}>Numb.Of Failed</Th>
              <Th sx={HeadStyle}>%Passed</Th>
              <Th sx={HeadStyle}>%Failed</Th>
              <Th sx={HeadStyle}>AverageFailureScore</Th>
              <Th sx={HeadStyle} w="50px"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((eUpgradeScore:any,ind:number) =><ROWSTYLE key={ind}>
              <Td sx={DataStyle}>{eUpgradeScore.ExamDiet || 'N/a'}</Td>
              <Td sx={DataStyle}>{eUpgradeScore.Level ||'N/A'}</Td>
              {/* <Td sx={DataStyle}>{allExamPeriod && allExamPeriod.find((ePeriod:any)=> ePeriod.Id == eUpgradeScore.ExamPeriodId)?.ExamName || 'N/A'}</Td> */}
              <Td sx={DataStyle}>{eUpgradeScore.Subject ||'0'}</Td>
              <Td sx={DataStyle}>{eUpgradeScore.NoOfCandidates ||'0'}</Td>
              <Td sx={DataStyle}>{eUpgradeScore.NoOfPassed ||'0'}</Td>
              {/* <Td sx={DataStyle}>{eUpgradeScore.Subject?eUpgradeScore.Subject.Subject:''}</Td> */}
              <Td sx={DataStyle}>{eUpgradeScore.NoOfFailed||'0'}</Td>
              <Td sx={DataStyle}>{eUpgradeScore.PercentagePassed||'0'}</Td>
              <Td sx={DataStyle}>{eUpgradeScore.PercentageFailed||'0'}</Td>
              <Td sx={DataStyle}>{eUpgradeScore.AverageFailureScore||'0'}</Td>
              <Td sx={DataStyle} w="50px" h="50px">
              </Td>
            </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Performance Report'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
